import { render, staticRenderFns } from "./AppMediaPrint.vue?vue&type=template&id=671a4798&"
import script from "./AppMediaPrint.vue?vue&type=script&lang=js&"
export * from "./AppMediaPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports